module.exports = __webpack_public_path__ + "static/media/cosrx_bg1_1.b8883a55.png";